import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoOrdiniDaClienteStep2Component } from './conservazione-carica-documento-ordini-da-cliente-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-ordini-da-cliente-step2', {
            url: '/conservazione-carica-documento-ordini-da-cliente',
            ncyBreadcrumb: {
                label: 'Carica Ordini da Cliente',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-ordini-da-cliente-step2 flex="100"></conservazione-carica-documento-ordini-da-cliente-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoOrdiniDaClienteStep2Module: string = ng
    .module('conservazione-carica-documento-ordini-da-cliente-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoOrdiniDaClienteStep2', ConservazioneCaricaDocumentoOrdiniDaClienteStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-ordini-da-cliente-step2/conservazione-carica-documento-ordini-da-cliente-step2.module.ts